var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('complaint-list',{attrs:{"mode":"assigned","api-url":"complaints/my/assigned","title":"Assigned to me","subtitle":"Complaints you were assigned to investigate. Open one to record your findings.","icon":"UserCheckIcon"}})}
var staticRenderFns = []

export { render, staticRenderFns }